export default __webpack_public_path__ + "static/media/Mark-3-HUD-Targeting (TD Missile).34f666dd.jpg";